import usePortal from "@hooks/use-portal";
import clsx from "clsx";
import { FC, useEffect } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

export type BackdropProps = {
  visible: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

export const Backdrop: FC<BackdropProps> = ({ visible, onClick }) => {
  const target = usePortal("modal-backdrop");

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (!target) return;

    const updateBodyOverflow = () => {
      if (target.querySelectorAll(".visible").length > 0) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    };

    updateBodyOverflow();

    return () => {
      updateBodyOverflow();
    };
  }, [target, visible]);

  return target
    ? createPortal(
        <StyledBackdrop
          onClick={onClick}
          className={clsx(visible && "visible")}
        />,
        target
      )
    : null;
};

const StyledBackdrop = styled.div`
  pointer-events: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s;
  &.visible {
    pointer-events: all;
    opacity: 1;
  }
`;
